import { apiToken, walletUrl, } from "../config"

export const walletAPI = async ({organizationId}) => {
    try {
        const response = await fetch(`${walletUrl}${organizationId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        
        return res.creditSummary;
    } catch(e) {
        console.error("Error fetching wallet data:", e);
        throw e; 
    }
}